import BatchAddVehicleInfoBusinessNoteModal from './batch-add-vehicle-info-business-note-modal.vue'
export default BatchAddVehicleInfoBusinessNoteModal
